import React from "react";
import AsyncSelect from "react-select/async";
import MaskedInput from "react-text-mask"
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import axios from "axios";
import FanFilterSelect from "./FanFilterSelect";
import FilterErrorIcon from "./FilterErrorIcon";

import { formInputContainerStyle, formInputStyle } from "./FanFilterGroupForm";

const MessageDataForm = (props) => {
  const {
    csrfToken,
    team,
    fanFilter,
    updateFanFilter,
  } = props;

  const supportedConditions = fanFilter.filter_param_options.condition || [];
  const supportedBehaviors = fanFilter.filter_param_options.behavior || [];
  const supportedTimePeriodUnits = fanFilter.filter_param_options.time_period_units || [];

  const messageDataType = fanFilter.filter_params.message_data_type || "";
  const trackables = fanFilter.filter_params.trackables || [];
  const condition = fanFilter.filter_params.condition || "";
  const behavior = fanFilter.filter_params.behavior || "";
  const timePeriodValue = fanFilter.filter_params.time_period_value || "";
  const timePeriodUnit = fanFilter.filter_params.time_period_unit || "";

  const debounceFetchMarketingTrackables = _.debounce((inputValue, callback) => {
    new Promise(resolve => {
      axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
      axios.get(`/teams/${team.id}/ahoy_messages/grouped_trackables_index.json?q=${inputValue}`)
        .then(function (response) {
          var options = response.data.map(function(group) {
            return {
              label: group.label,
              options: group.options.map(function(option) {
                const [trackable_type, trackable_id] = option.value.split("|");
                return {
                  value: {
                    trackable_id: trackable_id,
                    trackable_type: trackable_type,
                    label: option.label,
                  },
                  label: option.label,
                };
              }),
            };
          });

          callback(options);
        })
    });
  }, 250);

  return (
    <>
      <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Message data type"
          options={fanFilter.filter_param_options.message_data_type.map((filterType) => ({ value: filterType, label: filterType }))}
          value={messageDataType || null}
          onChange={(value) => updateFanFilter({
            filter_params: {
              message_data_type: value,
              ...(value !== "Email" && { trackables: [] }),
              ...(value !== "Any Email" && {
                time_period_value: "",
                time_period_unit: ""
              }),
            },
          })}
        />
      </div>
      {messageDataType === "Email" && (
        <div style={formInputContainerStyle}>
        <AsyncSelect
            classNamePrefix="react-select"
            menuPortalTarget={document.body}
          isMulti
          placeholder="select messages"
          defaultOptions
          value={trackables.map(trackable => ({
            value: {
              trackable_id: trackable.trackable_id,
              trackable_type: trackable.trackable_type,
              label: trackable.label,
            },
            label: trackable.label,
          }))}
          loadOptions={(inputValue, callback) => {
            return debounceFetchMarketingTrackables(inputValue, callback);
          }}
          formatGroupLabel={data => (
            <div style={{ color: "var(--sl-text-primary)" }}>
              <strong>{data.label}</strong>
            </div>
          )}
          getOptionLabel={option => option.label}
          onChange={options => {
            updateFanFilter({
              filter_params: {
                ...fanFilter.filter_params,
                trackables: options?.map(option => option.value) || []
              },
            })
          }}
          styles={{
            menuPortal: (baseStyles) => ({ ...baseStyles, zIndex: 9999 }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              minWidth: "260px",
              borderRadius: "8px",
              border: trackables.length ? "1px solid var(--sl-border-primary)" : "1px solid var(--sl-border-error)",
            }),
            menu: (baseStyles, state) => ({
              ...baseStyles,
              width: "max-content",
              maxWidth: "500px"
            }),
            multiValue: (styles, { isMulti, data, index }) => {
              return index === 0 ? styles : {
                ...styles,
                ':before': {
                  backgroundColor: 'var(--sl-bg-primary)',
                  content: '" or "',
                  color: 'var(--sl-text-primary)',
                  paddingLeft: '4px',
                  paddingRight: '8px',
                }
              };
            }
          }}
        />
        </div>
      )}
      <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Select a condition"
          placeholder="Select a condition"
          options={supportedConditions.map((operator) => ({ value: operator, label: operator }))}
          value={condition || null}
          onChange={(value) => updateFanFilter({
            filter_params: {
              ...fanFilter.filter_params,
              condition: value,
              behavior: "",
              ...((value !== "has" && value !== "has not") && {
                time_period_value: "",
                time_period_unit: ""
              }),
            },
          })}
        />
      </div>
      {condition && <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Select a behavior"
          placeholder="Select a behavior"
          options={supportedBehaviors.map((operator) => ({ value: operator, label: operator }))}
          value={behavior || null}
          onChange={(value) => updateFanFilter({
            filter_params: {
              ...fanFilter.filter_params,
              behavior: value,
            },
          })}
        />
      </div>}
      {messageDataType === "Any Email" && behavior && (
        <>
          <div style={formInputContainerStyle}>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <span style={{ fontSize: "14px", minWidth: "60px" }}>
                Within the last
              </span>
              <MaskedInput
                style={{
                  ...formInputStyle,
                  width: "80px",
                  textAlign: "center",
                  border: !timePeriodValue || !timePeriodUnit
                    ? "1px solid var(--sl-border-error)"
                    : "1px solid var(--sl-border-primary)",
                }}
                mask={createNumberMask({
                  prefix: "",
                  decimalLimit: 0,
                  integerLimit: 2
                })}
                value={timePeriodValue}
                onChange={(e) => updateFanFilter({
                  filter_params: {
                    ...fanFilter.filter_params,
                    time_period_value: e.target.value,
                  },
                })}
                placeholder="0"
                onFocus={(e) => {
                  e.target.select();
                }}
              />
              <FanFilterSelect
                aria-label="Select unit"
                placeholder="Select unit"
                width={160}
                options={supportedTimePeriodUnits.map((unit) => ({ value: unit, label: unit }))}
                value={timePeriodUnit || null}
                onChange={(value) => updateFanFilter({
                  filter_params: {
                    ...fanFilter.filter_params,
                    time_period_unit: value,
                  },
                })}
              />
            </div>
          </div>
        </>
      )}
      <FilterErrorIcon errors={fanFilter.filter_validation_errors} />
    </>
  );
};

export default MessageDataForm;
